import React, {ReactElement} from 'react';
import {ChecklistData} from '../../hooks/useChecklist';
import Checklist from './checklist';
import styles from './styles.module.scss';

interface ChecklistPageProps {
  checklistData: ChecklistData;
}

const ChecklistPage = ({checklistData}: ChecklistPageProps): ReactElement => (
  <>
    <div className={styles.headerContainer}>
      <h1 className="heading-1">Checklist</h1>
      <p className={styles.sectionSubtitle}>
        Items on the checklist will be automatically checked off for you once completed. Some items
        will display potential earnings for completing that action. Not every college will award for
        every action. Navigate to a college&apos;s page to learn more about what they award for.
      </p>
    </div>
    {checklistData.checklist && <Checklist groups={checklistData.checklist.groups} />}
  </>
);

export default ChecklistPage;
